import React from 'react';

import CategoryFilter from '../../molecules/category-filter/CategoryFIlter';
import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';
import { ISubSection } from '../../../typings/hlroom';
import styles from '../../../utils/styles';

import './Categories.scss';

export interface ICategories {
  subSections: ISubSection[];
  isDesktop: boolean;
  appType?: string;
}

const Categories: React.FC<ICategories> = ({ subSections, isDesktop, appType = 'sport' }) => {
  const title: string = 'Esplora per categoria';

  return (
    <div className={styles('categories')}>
      <div className={styles('categories__title')}>
        <TypograpyHeadingComponent text={title} headingTag="h2" />
      </div>

      <div className={styles('categories__body')}>
        {subSections
          .filter((subSection) => subSection.tag && subSection.description)
          .map((subSection, index) => (
            <CategoryFilter
              key={`${index}-${subSection.tag}`}
              {...subSection}
              isDesktop={isDesktop}
              appType={appType}
            />
          ))}
      </div>
    </div>
  );
};

export default Categories;
